import { render, staticRenderFns } from "./PageBar.vue?vue&type=template&id=21400524&scoped=true&"
import script from "./PageBar.vue?vue&type=script&lang=js&"
export * from "./PageBar.vue?vue&type=script&lang=js&"
import style0 from "./PageBar.vue?vue&type=style&index=0&id=21400524&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21400524",
  null
  
)

export default component.exports